module.exports = __webpack_public_path__ + "static/media/arrow-right.2b9cac37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DivisionSelector/arrow-right.svg
// module id = 1062
// module chunks = 0